import React, { Component } from "react";
import styled from "styled-components";
const Container = styled.div`
  height: 500px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Header = styled.h1`
  font-size: 4rem;
  font-weight: bold;
  text-align: center;
`;
export default class Error extends Component {
  render() {
    if (this.props.type === "Page" || this.props.type === "Product")
      return (
        <Container>
          <Header>{this.props.type} not found</Header>
        </Container>
      );
    else {
      return (
        <Container>
          <Header>Server error</Header>
        </Container>
      );
    }
  }
}
